import { ElementGroupSelectableRow } from "./ElementGroupSelectableRow";
import { ElementGroupRowIndex } from "./ElementGroupRowIndex";
import { ElementGroupRowTitle } from "./ElementGroupRowTitle";
import { ElementGroupRowCount } from "./ElementGroupRowCount";
import type { ElementGroupDefaultRowProps } from "./types";

export const ElementGroupDefaultRow = ({
  index,
  title,
  subtitle,
  highlightQuery,
  count,
  isSelected,
  onClick,
  rowRef,
  startAdornment,
  endAdornment,
  className,
  containerClassName,
  children,
  dataOnboarding,
}: ElementGroupDefaultRowProps) => {
  return (
    <ElementGroupSelectableRow
      isSelected={isSelected}
      onClick={onClick}
      rowRef={rowRef}
      dataOnboarding={dataOnboarding}
      left={
        <>
          {startAdornment}
          {index !== undefined && <ElementGroupRowIndex index={index} />}
          <ElementGroupRowTitle
            title={title}
            subtitle={subtitle}
            isSelected={isSelected}
            highlightQuery={highlightQuery}
          />
        </>
      }
      right={
        count !== undefined &&
        (typeof count === "number" ? (
          <ElementGroupRowCount count={count} />
        ) : (
          count
        ))
      }
      endAdornment={endAdornment}
      className={className}
      containerClassName={containerClassName}
    >
      {children}
    </ElementGroupSelectableRow>
  );
};
